import { connect } from 'react-redux';
import { Home } from './Home';
import { settingSelectors } from '@store/setting/selectors';
import { entitySelectors } from '@store/entity/selectors';
import { yourJourneySelectors } from '@store/yourJourney/selectors';

const mapStateToProps = (state, ownProps) => {
  const { homepage } = entitySelectors.getProperty(state, ownProps.id);

  const homepageId = homepage ? homepage.id : null;

  return {
    property: entitySelectors.getProperty(state),
    currentLanguage: settingSelectors.getUserLanguage,
    homepage: entitySelectors.getHomepage(state, homepageId),
    journeyParams: yourJourneySelectors.getParsedJourneyParams(state),
    tablesPage: entitySelectors.getTablesPage(state),
    products: entitySelectors.getAllProducts(state),
  };
};

export const HomeConnected: any = connect(mapStateToProps)(Home);
